import { PlanType } from "@brookbush/database";
import type { Price } from "@brookbush/types";

import { useAuth } from "@clerk/nextjs";
import { useMemo } from "react";
import useSWRImmutable from "swr/immutable";

import { selectMembershipPrices } from "~/lib/stripe/selectMembershipPrices";

const useStripePrices = (type: PlanType) => {
	const { userId } = useAuth();
	const {
		data: prices,
		isLoading,
		...rest
	} = useSWRImmutable<Price[]>(userId && `/stripe/prices/${type}`);

	const visiblePrices = useMemo(() => {
		if (type !== PlanType.INDIVIDUAL || !prices) return prices;

		return selectMembershipPrices(prices);
	}, [prices, type]);

	return {
		prices: visiblePrices,
		isLoadingPrices: isLoading,
		...rest,
	};
};

export default useStripePrices;
